import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import axiosRetry from 'axios-retry';
import * as auth from 'aws-amplify/auth';
import { ApiError } from './api-error';
import { ApiErrorCode } from './api-error-types';


export const API_ENDPOINT = 'https://api.weapps.net/prod';
export const AVATAR_ENDPOINT = `${API_ENDPOINT}/user/avatar`;

export class ApiUtils {
  private static client: AxiosInstance;

  static {
    this.client = axios.create({
      baseURL: API_ENDPOINT,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Retry config: retry 3 times on network errors or 5xx responses
    axiosRetry(this.client, {
      retries: 3,
      retryDelay: axiosRetry.exponentialDelay,
      retryCondition: (error) =>
        axiosRetry.isNetworkOrIdempotentRequestError(error) ||
        error.code === 'ECONNABORTED',
    });

    // Attach JWT token before requests
    this.client.interceptors.request.use(async (config) => {
      const token = await ApiUtils.getJwtToken();
      config.headers['Authorization'] = `Bearer ${token}`;
      return config;
    });
  }

  static async apiCall<TResponse>(
    method: 'get' | 'post' | 'put' | 'delete',
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<TResponse> {
    try {
      const response = await this.client.request<TResponse>({
        method,
        url,
        data,
        ...config,
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        const response = error.response?.data as any;
  
        if (status === 401) {
          throw new ApiError(ApiErrorCode.UNAUTHORIZED, 'Unauthorized access');
        }else {
          throw new ApiError(response?.reason,response?.message,response?.details);
        }
      }else{
        throw error;
      }
    }
  }
    

  private static async getJwtToken(): Promise<string> {
    try {
      const session = await auth.fetchAuthSession();
      const token = session.tokens?.idToken?.toString() || '';
      return token;
    } catch (error) {
      console.error('Error fetching JWT token:', error);
      throw error;
    }
  }
}


// app.use((err: any, req: express.Request, res: express.Response, next: express.NextFunction) => {
//   if (err instanceof ApiError) {
//     const statusCode =
//       err.code === ApiErrorCode.UNAUTHORIZED ? 401 :
//       400;

//     return res.status(statusCode).json({
//       result: ApiResultTypes.ERROR,
//       reason: err.code,
//       message: err.message,
//       details: err.details ?? null
//     });
//   }

//   console.error('Unhandled error:', err);
//   return res.status(500).json({
//     result: ApiResultTypes.ERROR,
//     reason: ApiErrorCode.GENERIC_ERROR,
//     message: 'Unexpected internal server error'
//   });
// });
